import { render, staticRenderFns } from "./HomeDashboardHub.vue?vue&type=template&id=1b071e5c&scoped=true"
import script from "./HomeDashboardHub.vue?vue&type=script&lang=js"
export * from "./HomeDashboardHub.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboardHub.vue?vue&type=style&index=0&id=1b071e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b071e5c",
  null
  
)

export default component.exports